export enum IncidentNibrsAttemptedCompletedType {
    Attempted = 'A',
    Completed = 'C'
}